module.exports = __webpack_public_path__ + "static/media/calender_white.afe9bfdf.svg";